var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(!_vm.newUi)?_c('PartsWithDocuments',{on:{"sessionExpired":_vm.sessionExpired,"openDocument":_vm.openDocument}}):_c('ContentManager',{on:{"sessionExpired":_vm.sessionExpired,"openDocument":_vm.openDocument}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }